import { postAdminAddress } from '../api/admin'

export const createAdminAddress = async (payload) => {
  const req = await postAdminAddress(payload)
  return { type: 'CREATE_ADMIN_ADDRESS_SUCCESS', data: req.address }
}
